// extracted by mini-css-extract-plugin
module.exports = {"savings-data":"styles_savings-data__ixFFz","line":"styles_line__lTpVr","savings-data__item":"styles_savings-data__item__R3Qf6"};